import { CompletionHistoryScreenDesktop } from '@ui/desktop/history/CompletionHistoryScreen.desktop';

/**
 * `CompletionHistoryScreen` — desktop-only per completion-history.md
 * (MC-14): "no phone-optimized tree this round... reachable from the phone
 * footer for discoverability, not designed mobile-first." Unlike Rewards/
 * Weekly Review/Objectives, there is no phone-tree switch here — this file
 * exists anyway (rather than App.tsx importing the desktop tree directly)
 * so the "one screen, one import" convention stays consistent across every
 * cross-surface destination, and so a future phone tree (if ever added)
 * has exactly one place to plug in.
 */
export function CompletionHistoryScreen({
  onOpenObjective,
}: {
  readonly onOpenObjective: (objectiveId: string) => void;
}) {
  return <CompletionHistoryScreenDesktop onOpenObjective={onOpenObjective} />;
}
